module.exports = __webpack_public_path__ + "img/fb-mob.990f1fd4.svg";